import { IconifyIcon } from 'iconify-icon'

export const IconJournalInstants: IconifyIcon = {
	body:
		'<svg xmlns="http://www.w3.org/2000/svg" width="185" height="128" viewBox="0 0 185 128"><g fill="#fff" fill-rule="evenodd"><path d="M185,127L174,96s13.038-18.588,11-35c0.624-16.67-22.047-62.094-94-61S-0.087,45.523,0,66c-0.319,16.376,19.033,60.983,94,62,0,0,34.6-1.761,52-12ZM10,68c-1.021-5.993.11-53.849,85-57,75.83,2.318,80,52,80,52s0.536,20.145-14,32l9,19-24-8s-29.421,13.373-54,12S16.762,106.257,10,68Z"/><text font-size="50px" text-anchor="middle" font-weight="700" transform="translate(91.33 73.504) scale(2.341)"><tspan x="0">...</tspan></text></g></svg>',
	width: 185,
	height: 128,
}
export default IconJournalInstants
